import React, { useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { MultiRouteMap } from "./components/live-view/live-view";

import { StopListing } from "./components/stops/stops-list";
import { StopCreate } from "./components/stops/stops-create";
import { StopView } from "./components/stops/stops-view";
import { TripsListing } from "./components/trips/trips-list";
import { TripsCreate } from "./components/trips/trips-create";
import { TripsView } from "./components/trips/trips-view";
import { LiveTrack } from "./components/live-view/live-track";
import { TripsCostListing } from "./components/trip-cost/trips-cost";
import { TripCostCreate } from "./components/trip-cost/trip-cost-create";
import { Dashboard } from "./components/dashboard/dashboard";
import { TripCostView } from "./components/trip-cost/trip-cost-view";
import { MilestoneCreate } from "./components/milestone/milestone-create";
import { MilestoneListing } from "./components/milestone/milestone-list";
import { TripLiveTrack } from "./components/live-view/trip-live-track";
import { VehicleListing } from "./components/vehicle/vehicle-list";
import { VehicleCreate } from "./components/vehicle/vehicle-create";
import { VehicleView } from "./components/vehicle/vehicle-view";
//Master
import CustomerList from "./components/master/customer/list";
import CustomerCreate from "./components/master/customer/create";
import CustomerView from "./components/master/customer/view";
import VendorList from "./components/master/vendors/list";
import VendorCreate from "./components/master/vendors/create";
import VendorView from "./components/master/vendors/view";
import Report from "./components/report/report";
import { getCookie } from "./getcookie";
import { useGlobal } from "./GlobalContext";
import axios from "axios";
import UnAuthorized from "./unauthorized";
import ProductListing from "./components/products/product-list";
import ProductCreate from "./components/products/product-create";
import ProductView from "./components/products/product-view";

function App() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  // List of paths where header should be hidden
  const hideHeaderPaths = ["/"];

  const { rolePermissionList, setRolePermissionList, userType, setUserType } =
    useGlobal();
  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await axios.get(adminApiUrl + "validatetoken", {
          headers: { Authorization: getCookie("mawalog") },
        });

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "transport",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie =
        "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  useEffect(() => {
    getRolePermission();
  }, []);
  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);
  const getRolePermission = async () => {
    try {
      const response = await axios
        .get(adminApiUrl + "get_role_permission/5", {
          params: {},
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*", // Required for CORS support to work
            Authorization: getCookie("mawalog"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              setUserType(response.data.user_type);
              setRolePermissionList(response.data.role_permission ?? []);
              localStorage.setItem(
                "rolePermissionList",
                JSON.stringify(response.data.role_permission ?? [])
              );
              localStorage.setItem("userType", response.data.user_type ?? "");
            } else {
              setRolePermissionList([]);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 401) {
              document.cookie =
                "redirectPath=" +
                window.location.href +
                "; path=/; domain=.mawalog.com";
              document.cookie = "mawalog=; path=/; domain=.mawalog.com";
              window.location.href = accountsUrl;
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };

  function checkPermission(menuName, permission) {
    console.log(rolePermissionList);
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  const ProtectedRoute = ({ isAllowed }) => {
    console.log("isAllowed", isAllowed);
    return isAllowed ? <Outlet /> : <Navigate to="/unauthorized" />;
  };
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/unauthorized" element={<UnAuthorized />}></Route>
          <Route path="/" element={<Dashboard />}></Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Dashboard", "menu_permission")}
              />
            }
          >
            <Route path="/dashboard" element={<Dashboard />}></Route>
          </Route>
          {/*  <Route path="/liveview" element={<MultiRouteMap />}></Route> */}
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Stops", "list_permission")}
              />
            }
          >
            <Route path="/stops" element={<StopListing />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Stops", "create_permission")}
              />
            }
          >
            <Route path="/stops/create" element={<StopCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Stops", "view_permission")}
              />
            }
          >
            <Route path="/stops/view" element={<StopView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trips", "list_permission")}
              />
            }
          >
            <Route path="/trips" element={<TripsListing />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trips", "create_permission")}
              />
            }
          >
            <Route path="/trips/create" element={<TripsCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trips", "view_permission")}
              />
            }
          >
            <Route path="/trips/view" element={<TripsView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trip cost", "list_permission")}
              />
            }
          >
            <Route path="/trip-cost" element={<TripsCostListing />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trip cost", "create_permission")}
              />
            }
          >
            <Route path="/cost/create" element={<TripCostCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Trip cost", "view_permission")}
              />
            }
          >
            <Route path="/cost/view" element={<TripCostView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Milestone", "list_permission")}
              />
            }
          >
            <Route path="/milestones" element={<MilestoneListing />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Milestone", "create_permission")}
              />
            }
          >
            <Route
              path="/milestone/create"
              element={<MilestoneCreate />}
            ></Route>
          </Route>

          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Live view", "list_permission")}
              />
            }
          >
            <Route path="/livetrack" element={<LiveTrack />}></Route>
            <Route path="/triptrack" element={<TripLiveTrack />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vehicle", "list_permission")}
              />
            }
          >
            <Route path="/vehicles" element={<VehicleListing />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vehicle", "create_permission")}
              />
            }
          >
            <Route path="/vehicle/create" element={<VehicleCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vehicle", "view_permission")}
              />
            }
          >
            <Route path="/vehicle/view" element={<VehicleView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Customer", "list_permission")}
              />
            }
          >
            <Route path="/customers" element={<CustomerList />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Customer", "create_permission")}
              />
            }
          >
            <Route path="/customer/create" element={<CustomerCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Customer", "view_permission")}
              />
            }
          >
            <Route path="/customer/view" element={<CustomerView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vendor", "list_permission")}
              />
            }
          >
            <Route path="/vendor" element={<VendorList />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vendor", "create_permission")}
              />
            }
          >
            <Route path="/vendor/create" element={<VendorCreate />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Vendor", "view_permission")}
              />
            }
          >
            <Route path="/vendor/view" element={<VendorView />}></Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={checkPermission("Report", "menu_permission")}
              />
            }
          >
            <Route path="/reports" element={<Report />}></Route>
          </Route>
          <Route path="/products" element={<ProductListing />}></Route>
          <Route path="/product/create" element={<ProductCreate />}></Route>
          <Route path="/product/view" element={<ProductView />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
